import React, { useState } from "react"
import { Col, Nav, NavItem, NavLink } from "reactstrap"
import { useDispatch } from "react-redux"
import { getTeams } from "store/createTeam/action"

const NavTabs = props => {
  const {
    setActiveTab,
    activeTab,
    userid,
    getTeamsData,
    setuserList,
    setselectedSubcategory,
    setselectedMainCategory,
    setselectedReport,
    setStartDate,
    setEndDate,
    setselectedSupervisor,
    setshowUserTable,
    selectedSupervisor,
    setsupervised,
    setreported,
    setAccordianColumn,
    hideAccessAllOthersbutton,
    hideapprove,
    setPageIndex,
    pageSize,
    canApproveAllTeams,
  } = props
  const dispatch = useDispatch()

  const toggleTab = tab => {
    const isAllOthers = tab === "3"
    // Admins approve across the org, so their Approval tab loads all pending teams (userId 0).
    const isApprovalAllForAdmin = tab === "1" && canApproveAllTeams
    const params = {
      userId: isAllOthers || isApprovalAllForAdmin ? 0 : userid,
      categoryid: 0,
      subcategoryid: 0,
      reporttoid: 0,
      supervisorid: 0,
      startDate: "",
      endDate: "",
      useridList: [],
      excludesupervisorid: tab == "1" ? (canApproveAllTeams ? 0 : userid) : 0,
      // "All Others" loads page 1 of approved teams server-side; other tabs keep the full load.
      approved: isAllOthers ? true : undefined,
      pagesize: isAllOthers ? pageSize || 20 : 0,
      pagenumber: isAllOthers ? 1 : 0,
    }
    if (activeTab !== tab) {
      setActiveTab(tab)
      if (isAllOthers && setPageIndex) setPageIndex(0)
      dispatch(getTeams(params))
    }
  }

  return (
    <Col sm="12" className="d-flex justify-content-end">
      <div className="navtab-main ">
        <Nav
          pills
          className="navtab-bg nav-justifies p-0 bg-primary bg-opacity-75"
        >
          {!hideapprove && (
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={activeTab === "1" ? "bg-primary" : "bg-orangelights"}
                onClick={() => {
                  toggleTab("1")
                  setuserList(null)
                  setselectedSubcategory(null)
                  setselectedMainCategory(null)
                  setselectedReport(null)
                  setselectedSupervisor(null)
                  setStartDate()
                  setEndDate()
                  setshowUserTable(false)
                  setsupervised(false)
                  setreported(false)
                  setAccordianColumn(false)
                }}
              >
                Approval
              </NavLink>
            </NavItem>
          )}

          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={activeTab === "2" ? "bg-primary" : "bg-orangelights"}
              onClick={() => {
                toggleTab("2")
                setuserList(null)
                setselectedSubcategory(null)
                setselectedMainCategory(null)
                setselectedReport(null)
                setselectedSupervisor(null)
                setStartDate()
                setEndDate()
                setshowUserTable(false)
                setsupervised(false)
                setreported(false)
                setAccordianColumn(false)
              }}
            >
              My Team
            </NavLink>
          </NavItem>
          {hideAccessAllOthersbutton == true && (
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={activeTab === "3" ? "bg-primary" : "bg-orangelights"}
                onClick={() => {
                  toggleTab("3")
                  setuserList(null)
                  setselectedSubcategory(null)
                  setselectedMainCategory(null)
                  setselectedReport(null)
                  setselectedSupervisor(null)
                  setStartDate()
                  setEndDate()
                  setshowUserTable(false)
                  setsupervised(false)
                  setreported(false)
                  setAccordianColumn(false)
                }}
              >
                All Others
              </NavLink>
            </NavItem>
          )}
        </Nav>
      </div>
    </Col>
  )
}
export default NavTabs
